import { Reveal, Overline } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Book Your Session",
    desc: "Choose the consultation that fits and reserve a time through the simple online scheduler.",
  },
  {
    num: "02",
    title: "Complete the Questionnaire",
    desc: "Share your health story, current challenges, and hopes beforehand, so your time together goes deeper.",
  },
  {
    num: "03",
    title: "Meet Online, One-on-One",
    desc: "Gather with Staci in a calm virtual space, from your own home, at your own pace.",
  },
  {
    num: "04",
    title: "Receive Follow-Up Guidance",
    desc: "Leave with clear, personal next steps and supportive guidance to carry into daily life.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Overline>How It Works</Overline>
        <h2 className="font-serif text-3xl leading-tight text-forest sm:text-4xl lg:text-5xl">
          Four gentle steps to <em className="italic text-gold">begin</em>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1}>
            <div data-testid={`how-it-works-step-${i + 1}`} className="group border-t border-forest/15 pt-8">
              <span className="font-serif text-5xl text-gold/70 transition-colors duration-500 group-hover:text-gold">
                {s.num}
              </span>
              <h3 className="mt-5 font-serif text-xl text-forest">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/70">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
